import React, { useMemo } from 'react';
import { CheckCircleSolidIcon, CheckCircleIcon } from '@fiverr-private/visuals';
import { Typography } from '@fiverr-private/typography';
import { Container, Stack } from '@fiverr-private/layout_components';
import { PASSWORD_ERROR_KEY_VALUES, newPasswordValidator } from '../../utils/validators/newPasswordValidator';
import { translate } from '../../utils/translate';

interface PasswordHintsProps {
    password: string;
}

export const PasswordHints: React.FC<PasswordHintsProps> = ({ password }) => {
    const passwordSchema = useMemo(() => newPasswordValidator(), []);

    const errorKeys = useMemo(() => {
        const parsedPassword = passwordSchema.safeParse(password);
        const errorMessages = parsedPassword.success
            ? []
            : parsedPassword.error.issues
                  .map((error) => ('params' in error ? error?.params?.errorKey : null))
                  .filter((errorKey): errorKey is string => typeof errorKey === 'string');

        return new Set(errorMessages);
    }, [password, passwordSchema]);

    return (
        <Stack direction="column" gap="1">
            {PASSWORD_ERROR_KEY_VALUES.map((key) => {
                const isError = errorKeys.has(key);
                const Icon = isError ? CheckCircleIcon : CheckCircleSolidIcon;
                const color = isError ? 'grey_900' : 'green_700';

                return (
                    <Container key={key} color={color} display="flex" alignItems="center">
                        <Icon color="currentColor" />

                        <Typography marginLeft="2.5" decoration={isError ? 'none' : 'lineThrough'} size="b_sm">
                            {translate(key)}
                        </Typography>
                    </Container>
                );
            })}
        </Stack>
    );
};
